<div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-4 mt-1" [class.ph-carte]="!!libelle">
	<h3 class="mobile-title m-0 d-flex align-items-center flex-wrap gap-2">
		@if (isBack) {
			<app-button-back></app-button-back>
		}
		@if (libelle) {
			<span class="ph-libelle">{{ libelle }}</span>
			@if (numero) {
				<span class="ph-numero">{{ numero }}</span>
			}
			@if (sousTitre) {
				<span class="ph-sous-titre">{{ sousTitre | uppercase }}</span>
			}
		} @else {
			<ng-content select="[titles]"></ng-content>
		}
	</h3>

	<div class="header-actions d-flex flex-wrap gap-2 align-items-center" [class.ph-actions-fixes]="actionsFixesMobile">
		<ng-content select="[actions]"></ng-content>
	</div>
</div>